import { useCallback, useEffect, useRef } from "react";
import { useRootSelector } from "store";
import { activeAccountTypeConfig } from "store/account/account-selector";

import { PaymentData } from "store/payments/payments-state";
import { calculateFee } from "utility";

import classes from "./Gpay.module.scss";

export interface Gpayprops {
  successHandler: (googlePayload?: any, resolve?: any) => void;
  paymentData?: PaymentData;
}

export const Gpay: React.FC<Gpayprops> = ({ successHandler, paymentData }) => {
  const gPayRef: any = useRef();
  const { currentPaymentMethod } = useRootSelector((state) => state.common);
  const config = useRootSelector(activeAccountTypeConfig);
  const { paymentCenter, client } = useRootSelector((state) => state.config);
  const convenienceFee = currentPaymentMethod
    ? config.paymentMethods[currentPaymentMethod].fees.ConvenienceFee
    : null;

  const transactionData = useCallback(() => {
    const fee = calculateFee(
      convenienceFee,
      paymentCenter.defaultFees.convenienceFee,
      paymentData?.paymentAmount,
    );

    return {
      currencyCode: "USD",
      countryCode: "US",
      totalPriceStatus: "FINAL",
      totalPrice: (+(paymentData?.paymentAmount || 0) + (fee || 0)).toString(),
      totalPriceLabel: "Total",
    };
  }, [
    paymentData?.paymentAmount,
    convenienceFee,
    paymentCenter.defaultFees.convenienceFee,
  ]);

  const gPayConfig = useCallback(() => {
    return {
      customerkey: client.customerKey,
      publicKey:
        "BNpvYANJS6oqUtOVokdm5pzJDGnQred/k66TUdlQs+lsZriZLIFxZZAFuIvoSefLgSZCvxhgn/sOP5Q10jUfip8=", //TODO: NEDD TO FETCH key from configration
      type: "PAYMENT",
    };
  }, [client.customerKey]);

  const callback = useCallback(
    (payload: any) => {
      return new Promise((resolve) => {
        const googlePayload = {
          googlePayload: {
            paymentData: payload,
            transactionInfo: transactionData(),
          },
          paymentMethod: {
            paymentMethodType: 3,
          },
        };
        successHandler(googlePayload, resolve);
      });
    },
    [successHandler, transactionData],
  );

  useEffect(() => {
    const gpay = gPayRef.current;
    if (gpay) {
      gpay.addEventListener("gpay-success", (e: any) => {
        console.log(e.detail);
      });
      gpay.addEventListener("gpay-error", (e: any) => {
        console.log(e.detail);
      });
    }
    return () => {
      gpay.removeEventListener("gpay-success", (e: any) => {
        console.log(e);
      });
      gpay.removeEventListener("gpay-error", (e: any) => {
        console.log(e);
      });
    };
  }, []);

  useEffect(() => {
    const gpay = gPayRef.current;
    if (gpay._transactionData === null)
      gpay.renderGpay(gPayConfig(), transactionData(), callback);
  }, [gPayConfig, transactionData, callback]);

  return (
    <div className={classes.Wrapper}>
      <ft-google-pay ref={gPayRef}></ft-google-pay>
    </div>
  );
};
